<div [ngClass]="{ 'pe-none': isDisabled }">
  <label-field
    [text]="labelText"
    [isRequired]="isRequired"
    [isDisabled]="isDisabled"
    [hasRequiredValidator]="hasRequiredValidators()"
  >
    <div
      class="input-container d-flex align-items-center mt-2"
      [ngClass]="{
        'error-border': control && control.invalid && control.touched
      }"
    >
      <ng-container
        *ngIf="inputType === 'email' || inputType === 'number'"
        class="me-2"
      >
        <img
          [src]="'assets/images/' + inputType + '.svg'"
          [ngClass]="{
            'opacity-50': isDisabled
          }"
          [class]="inputType + '-icon me-2'"
        />
      </ng-container>
      <input
        #input
        class="input w-100"
        [ngClass]="{ disabled: isDisabled }"
        [placeholder]="placeholderText"
        [type]="inputType"
        (input)="onValueChange()"
        (focusout)="onFocusOut()"
      />
    </div>
  </label-field>
  <error-message
    *ngIf="control && control.invalid && control.touched"
    [validationErrors]="control.errors"
    [customErrorMessage]="customErrorMessage"
  ></error-message>
</div>
